// States data is duplicated from `/server/src/vendor/zenoti/states.ts`
// and comes from the zenoti api
// https://docs.zenoti.com/reference/retrieve-the-list-of-all-states-of-a-country
export interface State {
  id: number;
  name: string;
  short_name: string;
}

export const states: State[] = [
  {
    id: -1,
    name: 'Select State',
    short_name: '',
  },
  {
    id: 36,
    name: 'Alabama',
    short_name: 'AL',
  },
  {
    id: 37,
    name: 'Alaska',
    short_name: 'AK',
  },
  {
    id: 123,
    name: 'American Samoa Territory',
    short_name: 'AS',
  },
  {
    id: 38,
    name: 'Arizona',
    short_name: 'AZ',
  },
  {
    id: 39,
    name: 'Arkansas',
    short_name: 'AR',
  },
  {
    id: 3230,
    name: 'Armed Forces America',
    short_name: 'AA',
  },
  {
    id: 3231,
    name: 'Armed Forces Pacific',
    short_name: 'AP',
  },
  {
    id: 40,
    name: 'California',
    short_name: 'CA',
  },
  {
    id: 41,
    name: 'Colorado',
    short_name: 'CO',
  },
  {
    id: 42,
    name: 'Connecticut',
    short_name: 'CT',
  },
  {
    id: 43,
    name: 'Delaware',
    short_name: 'DE',
  },
  {
    id: 122,
    name: 'District of Columbia',
    short_name: 'DC',
  },
  {
    id: 44,
    name: 'Florida',
    short_name: 'FL',
  },
  {
    id: 45,
    name: 'Georgia',
    short_name: 'GA',
  },
  {
    id: 125,
    name: 'Guam Territory',
    short_name: 'GU',
  },
  {
    id: 46,
    name: 'Hawaii',
    short_name: 'HI',
  },
  {
    id: 47,
    name: 'Idaho',
    short_name: 'ID',
  },
  {
    id: 48,
    name: 'Illinois',
    short_name: 'IL',
  },
  {
    id: 49,
    name: 'Indiana',
    short_name: 'IN',
  },
  {
    id: 50,
    name: 'Iowa',
    short_name: 'IA',
  },
  {
    id: 51,
    name: 'Kansas',
    short_name: 'KS',
  },
  {
    id: 52,
    name: 'Kentucky',
    short_name: 'KY',
  },
  {
    id: 53,
    name: 'Louisiana',
    short_name: 'LA',
  },
  {
    id: 54,
    name: 'Maine',
    short_name: 'ME',
  },
  {
    id: 126,
    name: 'Marshall Islands Territory',
    short_name: 'MH',
  },
  {
    id: 55,
    name: 'Maryland',
    short_name: 'MD',
  },
  {
    id: 56,
    name: 'Massachusetts',
    short_name: 'MA',
  },
  {
    id: 57,
    name: 'Michigan',
    short_name: 'MI',
  },
  {
    id: 58,
    name: 'Minnesota',
    short_name: 'MN',
  },
  {
    id: 59,
    name: 'Mississippi',
    short_name: 'MS',
  },
  {
    id: 60,
    name: 'Missouri',
    short_name: 'MO',
  },
  {
    id: 61,
    name: 'Montana',
    short_name: 'MT',
  },
  {
    id: 62,
    name: 'Nebraska',
    short_name: 'NE',
  },
  {
    id: 63,
    name: 'Nevada',
    short_name: 'NV',
  },
  {
    id: 64,
    name: 'New Hampshire',
    short_name: 'NH',
  },
  {
    id: 65,
    name: 'New Jersey',
    short_name: 'NJ',
  },
  {
    id: 66,
    name: 'New Mexico',
    short_name: 'NM',
  },
  {
    id: 67,
    name: 'New York',
    short_name: 'NY',
  },
  {
    id: 68,
    name: 'North Carolina',
    short_name: 'NC',
  },
  {
    id: 69,
    name: 'North Dakota',
    short_name: 'ND',
  },
  {
    id: 127,
    name: 'Northern Mariana Islands',
    short_name: 'MP',
  },
  {
    id: 70,
    name: 'Ohio',
    short_name: 'OH',
  },
  {
    id: 71,
    name: 'Oklahoma',
    short_name: 'OK',
  },
  {
    id: 72,
    name: 'Oregon',
    short_name: 'OR',
  },
  {
    id: 128,
    name: 'Palau Territory',
    short_name: 'PW',
  },
  {
    id: 73,
    name: 'Pennsylvania',
    short_name: 'PA',
  },
  {
    id: 129,
    name: 'Puerto Rico',
    short_name: 'PR',
  },
  {
    id: 74,
    name: 'Rhode Island',
    short_name: 'RI',
  },
  {
    id: 75,
    name: 'South Carolina',
    short_name: 'SC',
  },
  {
    id: 76,
    name: 'South Dakota',
    short_name: 'SD',
  },
  {
    id: 77,
    name: 'Tennessee',
    short_name: 'TN',
  },
  {
    id: 78,
    name: 'Texas',
    short_name: 'TX',
  },
  {
    id: 130,
    name: 'U.S. Minor Outlying Islands',
    short_name: 'UM',
  },
  {
    id: 79,
    name: 'Utah',
    short_name: 'UT',
  },
  {
    id: 80,
    name: 'Vermont',
    short_name: 'VT',
  },
  {
    id: 131,
    name: 'Virgin Islands of the U.S.',
    short_name: 'VI',
  },
  {
    id: 81,
    name: 'Virginia',
    short_name: 'VA',
  },
  {
    id: 82,
    name: 'Washington',
    short_name: 'WA',
  },
  {
    id: 83,
    name: 'West Virginia',
    short_name: 'WV',
  },
  {
    id: 84,
    name: 'Wisconsin',
    short_name: 'WI',
  },
  {
    id: 85,
    name: 'Wyoming',
    short_name: 'WY',
  },
  {
    id: -2,
    name: 'Others',
    short_name: '',
  },
];
